import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { selectGroupGuid, useAppSelector } from '../../slices/commonSelectors';
import { useActualIncidentId } from 'components/IAP/hooks/commonHooks';
import { toast } from 'react-toastify';
import { icsIncidentLocationsKeys } from './icsIncidentLocation.queryKeys';
import { internalLayerVersionsKeys } from 'hooks/internalLayerVersion/queryKeys';
import { UpdateIcsIncidentLocationBody } from './icsIncidentLocation.types';
import { parseError } from 'hooks/shared/error';

export const useUpdateLocation = () => {
  const queryClient = useQueryClient();
  const groupGuid = useAppSelector(selectGroupGuid);
  const incidentId = useActualIncidentId();

  return useMutation({
    mutationFn: async (location: UpdateIcsIncidentLocationBody) => {
      const response = await axios.patch(
        `${config.apiGateway.ics_locations}/${location.id}`,
        { ...location, incidentId, groupGuid }
      );
      return response.data;
    },
    onSuccess: (data) => {
      toast.success(`Location "${data.name}" updated successfully`);
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: icsIncidentLocationsKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });
    },
  });
};
